module.exports = __webpack_public_path__ + "static/img/MD-2035.e159144.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/custom/MD-2035.jpg
// module id = +mr/
// module chunks = 0